import EMPLOYMENT_TYPES from '../../../../localizations/config/NO/digifinans/employment-types';
import HOME_TYPES from '../../../../localizations/config/NO/digifinans/home-types';
import MARITAL_STATUS from '../../../../localizations/config/NO/digifinans/marital-status';
import DEPENDANTS from '../../../../localizations/config/NO/digifinans/dependants';
import EDUCATION_TYPES from '../../../../localizations/config/NO/digifinans/education-types';
import LOAN_LIMITS from '../../../../localizations/config/NO/shared/loan-limits';
import { LOAN_PURPOSES } from '../../../../localizations/config/NO/digifinans/loan-purposes';

import {
  email,
  mergeLoan,
  dependants,
  homeType,
  civilStatus,
  homeCost,
  employmentType,
  employerName,
  purpose,
} from '../../../../validators';

import validateTotalLoan from '../../../../validators/totalLoan';
import validateRepaymentTime from '../../../../validators/repaymentTime';
import validateMoveInDate from '../../../../validators/NO/validateMoveInDate';
import monthlySalaryAfterTax from '../../../../validators/NO/monthlySalaryAfterTax';
import { validateAnnualSalaryBeforeTax, spouseAnnualIncomeBeforeTaxValidator } from '../../../../validators/NO/annualSalaryBeforeTax';
import otherIncomeAfterTax from '../../../../validators/otherIncomeAfterTax';
import { validateEmploymentSinceYear, validateEmploymentSinceMonth } from '../../../../validators/employedSince';
import phoneNumber from '../../../../validators/NO/phoneNumber';
import { validateRequiredButtonGroup } from '../../../../validators/requiredButtonGroup';
import validateNationalId from '../../../../validators/NO/nationalId';
import validateRentalIncome from '../../../../validators/NO/rentalIncome';
import { validateCurrentLoans, validateMonthlyCostCurrentLoans } from '../../../../validators/NO/currentLoans';

import textResource from '../../../../utils/text-resources/digifinans/NO/messages';
import submit from '../../../../mappers/NO/application';

const tooltip = (text) => {
  const temp = {
    trigger: 'focus',
    text,
    width: 'fill',
    position: 'right',
  };
  return temp;
};

const data = {
  general: {
    mapper: submit,
  },
  links: {
    quickReapply: '/returning-customer/',
    quickReapplyEng: '/en/returning-customer/',
    userAgreementEng: 'https://www.sambla.se/en/user-agreement/',
    userAgreement: 'https://www.sambla.no/om-sambla/brukeravtale/',
    dataPolicy: 'https://www.sambla.no/om-sambla/personvernerklaering/',
    dataPolicyEng: 'https://www.sambla.se/en/data-protection-policy/',
  },
  slides: [
    {
      title: textResource.slideTitleOne,
      fullview: false,
      coApplicantSlide: false,
      showBackButton: true,
      backButtonDestinationPath: '/',
      fields: [
        {
          component: 'ValidatedForm',
          form: 'Slider',
          props: {
            label: textResource.applicationLoanAmountLabel,
            showLabel: true,
            name: 'totalAmount',
            showButtons: false,
            type: 'tel',
            lead: true,
            layout: {
              start: 1,
              end: 4,
            },
            sliderConfig: {
              range: {
                min: 5000,
                max: 800000,
              },
              step: LOAN_LIMITS.STEP,
            },
          },
        },
        {
          component: 'StoreValueDisplay',
          props: {
            value: 'totalAmount',
            fontWeight: 'bold',
            noLabel: true,
            fontSize: '1rem',
            fieldDisplay: {
              name: 'totalAmount',
              maxValue: 800000,
              validate: validateTotalLoan,
              validateOnRegister: true,
              type: 'tel',
              suffix: textResource.loanCalculatorCurrencySuffix,
              isNumber: true,
              placeholder: textResource.applicationLoanAmountPlaceholder,
              unstyled: true,
            },
            layout: {
              start: 5,
              end: 7,
            },
          },
        },
        {
          component: 'FormTextBlock',
          props: {
            text: textResource.repaymentTimeWarning,
            transparent: false,
            visibleWhen: 'return(formState.values.totalAmount > 600000)',
            margin: false,
            special: true,
            center: true,
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'Slider',
          props: {
            name: 'repaymentTime',
            type: 'tel',
            lead: true,
            showLabel: true,
            label: textResource.repaymentTimeLabel,
            sliderConfig: {
              range: {
                min: 1,
                max: 15,
              },
            },
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'StoreValueDisplay',
          props: {
            value: 'repaymentTime',
            fontWeight: 'bold',
            position: 'space-between',
            fontSize: '1rem',
            noLabel: true,
            fieldDisplay: {
              name: 'repaymentTime',
              type: 'tel',
              maxValue: 15,
              validate: validateRepaymentTime,
              validateOnRegister: true,
              textAlign: '',
              suffix: textResource.loanCalculatorRepaymentTimeSuffix,
              placeholder: textResource.repaymentTimePlaceholder,
              unstyled: true,
            },
            layout: {
              start: 5,
              end: 7,
            },
          },
        },
        {
          component: 'FormTextBlock',
          props: {
            text: textResource.repaymentTimeWarning,
            transparent: false,
            visibleWhen: 'return(formState.values.repaymentTime > 5 &&  formState.values.experimentID !== "DigiRepaymentTime")',
            margin: true,
            special: true,
            center: false,
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'FormTextBlock',
          props: {
            text: textResource.repaymentTimeWarning,
            transparent: false,
            visibleWhen: 'return(formState.values.repaymentTime === 5 && formState.values.merge === false && formState.values.experimentID === "DigiRepaymentTime")',
            margin: false,
            special: true,
            center: true,
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          props: {
            name: 'merge',
            label: textResource.currentLoanMergeLabel,
            hasValidateFunction: true,
            buttonLayout: 'toggle',
            validate: mergeLoan,
            layout: {
              start: 1,
              end: 7,
            },
            buttons: [
              {
                label: textResource.mergeLoanYes,
                value: 'true',
              },
              {
                label: textResource.mergeLoanNo,
                value: 'false',
              },
            ],
            tooltip: tooltip(textResource.currentLoanMergeTooltip),
          },
        },
        {
          component: 'ConsolidationLoanAmountInput',
          props: {
            name: 'consolidationAmount',
            consolidationLabel: textResource.combinedLoanConsolidationAmount,
            hasValidateFunction: true,
            visibleWhen: 'return (formState.values.merge === true);',
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'MonthlyCost',
          props: {
            label: textResource.monthlyCostApproximateMonthlyCostLabel,
            approximateMonthlyCostMobile: textResource.approximateMonthlyCostMobile,
            repaymentTimeLimit: '>5',
            minimal: true,
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'Break',
          props: {
            shade: 'down',
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          props: {
            name: 'purpose',
            label: textResource.purposeHeaderText,
            dynamicLabel: [
              {
                type: 'calculation',
                visibleWhen: 'return (formState.values.merge === false || parseInt(formState.values.totalAmount) > parseInt(formState.values.consolidationAmount));',
                originalLabel: textResource.purposeHeaderText,
                values: [
                  {
                    label: textResource.newPurposeHeaderText,
                  },
                ],
              },
            ],
            placeholder: textResource.purposeHeaderText,
            hasValidateFunction: true,
            validate: purpose,
            visibleWhen: 'return (formState.values.merge === false || (formState.values.totalAmount > formState.values.consolidationAmount ));',
            buttons: LOAN_PURPOSES,
            tooltip: tooltip(textResource.purposeTooltip),
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'EmailInput',
          sectionName: 'applicant',
          props: {
            name: 'phoneNumber',
            type: 'tel',
            tooltip: tooltip(textResource.phoneNumberTooltip),
            label: textResource.phoneNumberLabel,
            placeholder: textResource.phoneNumberPlaceholder,
            hasValidateFunction: true,
            validate: phoneNumber,
            lead: true,
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant',
          props: {
            name: 'email',
            label: textResource.emailLabel,
            placeholder: textResource.emailPlaceholder,
            tooltip: tooltip(textResource.emailTooltip),
            hasValidateFunction: true,
            validate: email,
            lead: true,
            layout: {
              start: 4,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant',
          props: {
            name: 'nationalId',
            label: textResource.nationalIdLabel,
            validate: validateNationalId,
            placeholder: textResource.nationalIdPlaceholder,
            hasValidateFunction: true,
            tooltip: tooltip(textResource.nationalIdTooltip),
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'applicant',
          props: {
            name: 'civilStatus',
            label: textResource.civilStatusLabel,
            hasValidateFunction: true,
            validate: civilStatus,
            buttons: MARITAL_STATUS,
            tooltip: tooltip(textResource.civilStatusTooltip),
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'applicant',
          props: {
            name: 'dependants',
            label: textResource.dependantsLabel,
            hasValidateFunction: true,
            buttonLayout: 'compact',
            validate: dependants,
            buttons: DEPENDANTS,
            tooltip: tooltip(textResource.dependantsTooltip),
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'applicant',
          props: {
            name: 'educationLevel',
            hasValidateFunction: true,
            validate: validateRequiredButtonGroup,
            label: textResource.educationLabel,
            placeholder: textResource.educationLabel,
            buttons: EDUCATION_TYPES,
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'AcceptNewsLetter',
          form: 'Checkbox',
          props: {
            name: 'acceptNewsletter',
            text: textResource.samblaPlusText,
            linkText: textResource.samblaPlusReadMore,
            links: {
              NO: 'https://digifinans.no/digifinans-plus',
              EN: 'https://digifinans.no/digifinans-plus',
            },
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'UserAgreementDataPolicy',
          props: {
            lead: true,
            userAgreement: 'https://digifinans.no/brukeravtale',
            dataPolicy: 'https://digifinans.no/personvernerklaering',
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
      ],
    },
    {
      title: textResource.slideTitleThree,
      fullview: false,
      coApplicantSlide: false,
      showBackButton: true,
      fields: [
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'applicant',
          props: {
            name: 'homeType',
            label: textResource.homeTypeLabel,
            hasValidateFunction: true,
            validate: homeType,
            buttons: HOME_TYPES,
            tooltip: tooltip(textResource.homeTypeTooltip),
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'EmploymentSinceInputYear',
          sectionName: 'applicant',
          props: {
            name: 'moveInDate',
            label: textResource.moveInDateLabel,
            placeholder: textResource.moveInDatePlaceholder,
            validate: validateMoveInDate,
            hasValidateFunction: true,
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant',
          props: {
            name: 'homeCost',
            isNumber: true,
            label: textResource.homeCostLabel,
            validate: homeCost,
            placeholder: textResource.homeCostPlaceholder,
            hasValidateFunction: true,
            type: 'tel',
            tooltip: tooltip(textResource.homeCostTooltip),
            layout: {
              start: 4,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant.currentLoans.houseLoan',
          props: {
            isNumber: true,
            name: 'amount',
            placeholder: textResource.houseLoansAmountPlaceholder,
            label: textResource.houseLoansAmountLabel,
            type: 'tel',
            validate: validateCurrentLoans,
            hasValidateFunction: true,
            tooltip: tooltip(textResource.houseLoanAmountTooltip),
            visibleWhen: 'return (formState.values.applicant.homeType === "villa" || formState.values.applicant.homeType === "condominium" || formState.values.applicant.homeType === "ownedApartment");',
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant.currentLoans.houseLoan',
          props: {
            isNumber: true,
            name: 'monthlyCost',
            tooltip: tooltip(textResource.houseLoanMonthlyCostTooltip),
            label: textResource.houseLoansMonthlyCostLabel,
            placeholder: textResource.houseLoansMonthlyCostPlaceholder,
            type: 'tel',
            validate: validateMonthlyCostCurrentLoans,
            hasValidateFunction: true,
            visibleWhen: 'return (formState.values.applicant.homeType === "villa" || formState.values.applicant.homeType === "condominium" || formState.values.applicant.homeType === "ownedApartment");',
            layout: {
              start: 4,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'applicant',
          props: {
            name: 'houseLoanPart',
            label: textResource.houseLoansPartLabel,
            hasValidateFunction: true,
            buttonLayout: 'toggle',
            visibleWhen: 'return (formState.values.applicant.homeType === "villa" || formState.values.applicant.homeType === "condominium" || formState.values.applicant.homeType === "ownedApartment");',
            layout: {
              start: 1,
              end: 7,
            },
            buttons: [
              {
                label: textResource.houseLoansLoanIsOwnedByApplicant,
                value: '100',
              },
              {
                label: textResource.houseLoansLoanIsSharedWithCoApplicant,
                value: '50',
              },
            ],
          },
        },
      ],
    },
    {
      title: textResource.slideTitleTwo,
      fullview: false,
      coApplicantSlide: false,
      showBackButton: true,
      fields: [
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'applicant',
          props: {
            name: 'employmentType',
            label: textResource.employmentTypeLabel,
            placeholder: textResource.employmentTypeLabel,
            hasValidateFunction: true,
            validate: employmentType,
            buttons: EMPLOYMENT_TYPES,
            tooltip: tooltip(textResource.employmentTypeTooltip),
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant',
          props: {
            name: 'employerName',
            validate: employerName,
            layout: {
              start: 1,
              end: 4,
            },
            hasValidateFunction: true,
            label: textResource.employerNameLabel,
            placeholder: textResource.employerNamePlaceholder,
            dynamicLabel: [
              {
                key: 'employmentType',
                originalLabel: textResource.employerNameLabel,
                values: [
                  {
                    name: 'selfEmployed',
                    sectionName: 'applicant',
                    label: textResource.selfEmployedEmployerNameDynamicLabel,
                  },
                ],
              },
            ],
            tooltip: tooltip(textResource.employerNameTooltip),
            visibleWhen: 'return (formState.values.applicant.employmentType !== undefined && (formState.values.applicant.employmentType !== "disabilityPension" && formState.values.applicant.employmentType !== "retired" && formState.values.applicant.employmentType !== "student" && formState.values.applicant.employmentType !== "unemployed" && formState.values.applicant.employmentType !== "rehabilitation") );',
          },
        },
        {
          component: 'EmploymentSinceInputYear',
          sectionName: 'applicant',
          props: {
            name: 'employmentSince',
            layout: {
              start: 1,
              end: 4,
            },
            label: textResource.employmentSinceYearLabel,
            dynamicLabel: [
              {
                key: 'employmentType',
                originalLabel: textResource.employmentSinceYearLabel,
                values: [
                  {
                    name: 'selfEmployed',
                    sectionName: 'applicant',
                    label: textResource.selfEmployedSinceYearDynamicLabel,
                  },
                  {
                    name: 'student',
                    sectionName: 'applicant',
                    label: textResource.studentSinceYearDynamicLabel,
                  },
                  {
                    name: 'retired',
                    sectionName: 'applicant',
                    label: textResource.retiredSinceDynamicLabel,
                  },
                  {
                    name: 'disabilityPension',
                    sectionName: 'applicant',
                    label: textResource.disabilityPensionSinceDynamicLabel,
                  },
                  {
                    name: 'unemployed',
                    sectionName: 'applicant',
                    label: textResource.unemployedSinceDynamicLabel,
                  },
                ],
              },
            ],
            placeholder: textResource.employmentSinceYearPlaceholder,
            validate: validateEmploymentSinceYear,
            hasValidateFunction: true,
          },
        },
        {
          component: 'EmploymentSinceInputMonth',
          sectionName: 'applicant',
          props: {
            name: 'employmentSinceMonth',
            validate: validateEmploymentSinceMonth,
            hasValidateFunction: true,
            label: textResource.employmentSinceMonthLabel,
            layout: {
              start: 4,
              end: 7,
            },
            dynamicLabel: [
              {
                key: 'employmentType',
                originalLabel: textResource.employmentSinceMonthLabel,
                values: [
                  {
                    name: 'selfEmployed',
                    sectionName: 'applicant',
                    label: textResource.selfEmployedSinceMonthDynamicLabel,
                  },
                  {
                    name: 'student',
                    sectionName: 'applicant',
                    label: textResource.studentSinceMonthDynamicLabel,
                  },
                  {
                    name: 'retired',
                    sectionName: 'applicant',
                    label: textResource.retiredSinceDynamicLabel,
                  },
                  {
                    name: 'disabilityPension',
                    sectionName: 'applicant',
                    label: textResource.disabilityPensionSinceMonthsDynamicLabel,
                  },
                ],
              },
            ],
            placeholder: textResource.employedSinceMonthPlaceholder,
            visibleWhen: 'return (formState.values.applicant.employmentSince > new Date().getFullYear() - 4);',
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant',
          props: {
            name: 'annualIncomeBeforeTax',
            isNumber: true,
            label: textResource.annualIncomeLabel,
            placeholder: textResource.monthlySalaryPlaceholder,
            validate: validateAnnualSalaryBeforeTax,
            tooltip: tooltip(textResource.annualIncomeBeforeTaxTooltip),
            hasValidateFunction: true,
            type: 'tel',
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant',
          props: {
            name: 'monthlyIncomeAfterTax',
            isNumber: true,
            label: textResource.monthlyIncomeAfterTaxLabel,
            placeholder: textResource.monthlyIncomeAfterTaxPlaceholder,
            validate: monthlySalaryAfterTax,
            hasValidateFunction: true,
            tooltip: tooltip(textResource.monthlyIncomeAfterTaxTooltip),
            type: 'tel',
            layout: {
              start: 4,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'applicant',
          props: {
            name: 'otherIncome',
            label: textResource.otherIncomeLabel,
            hasValidateFunction: true,
            buttonLayout: 'toggle',
            layout: {
              start: 1,
              end: 7,
            },
            buttons: [
              {
                label: textResource.mergeLoanYes,
                value: 'true',
              },
              {
                label: textResource.mergeLoanNo,
                value: 'false',
              },
            ],
            tooltip: tooltip(textResource.otherIncomeTooltip),
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant',
          props: {
            isNumber: true,
            name: 'otherMonthlyIncomeAfterTax',
            placeholder: textResource.netOtherIncomePlaceholder,
            label: textResource.netOtherIncomeLabel,
            type: 'tel',
            visibleWhen: 'return (formState.values.applicant.otherIncome !== undefined && formState.values.applicant.otherIncome === true);',
            validate: otherIncomeAfterTax,
            hasValidateFunction: true,
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant',
          props: {
            name: 'spouseAnnualIncomeBeforeTax',
            validate: spouseAnnualIncomeBeforeTaxValidator,
            isNumber: true,
            hasValidateFunction: true,
            label: textResource.spouseAnnualIncomeLabel,
            placeholder: textResource.monthlySalaryPlaceholder,
            type: 'tel',
            layout: {
              start: 1,
              end: 4,
            },
            visibleWhen: 'return (formState.values.applicant.civilStatus && (formState.values.applicant.civilStatus === "married" || formState.values.applicant.civilStatus === "partner"));',
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'applicant',
          props: {
            name: 'hasRentalIncome',
            label: textResource.hasRentalIncomeLabel,
            hasValidateFunction: true,
            buttonLayout: 'toggle',
            layout: {
              start: 1,
              end: 7,
            },
            buttons: [
              {
                label: textResource.mergeLoanYes,
                value: 'true',
              },
              {
                label: textResource.mergeLoanNo,
                value: 'false',
              },
            ],
            tooltip: tooltip(textResource.hasRentalIncomeTooltip),
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant',
          props: {
            name: 'rentalMonthlyIncomeBeforeTax',
            isNumber: true,
            label: textResource.rentalMonthlyIncomeBeforeTaxLabel,
            placeholder: textResource.rentalMonthlyIncomeBeforeTaxPlaceholder,
            type: 'tel',
            visibleWhen: 'return (formState.values.applicant.hasRentalIncome);',
            validate: validateRentalIncome,
            hasValidateFunction: true,
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
      ],
    },
    {
      title: textResource.slideTitleFour,
      fullview: false,
      coApplicantSlide: false,
      showBackButton: true,
      fields: [
        {
          component: 'FormTextBlock',
          props: {
            text: textResource.addCoApplicantDesc,
            tooltip: tooltip(textResource.addCoApplicantTooltip),
            transparent: true,
            header: true,
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          props: {
            label: textResource.addCoApplicantLabel,
            name: 'hasCoApplicant',
            buttonLayout: 'toggle',
            buttons: [
              {
                label: textResource.mergeLoanYes,
                value: 'true',
              },
              {
                label: textResource.mergeLoanNo,
                value: 'false',
              },
            ],
            tooltip: tooltip(textResource.addCoApplicantTooltip),
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'FormTextBlock',
          props: {
            name: 'textbox2',
            text: textResource.currentLoansInformation,
            transparent: true,
            header: true,
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'applicant',
          props: {
            name: 'hasCarLoan',
            label: textResource.carLoansLabel,
            tooltip: tooltip(textResource.carLoanTooltip),
            hasValidateFunction: true,
            buttonLayout: 'toggle',
            validate: validateRequiredButtonGroup,
            layout: {
              start: 1,
              end: 7,
            },
            buttons: [
              {
                label: textResource.mergeLoanYes,
                value: 'true',
              },
              {
                label: textResource.mergeLoanNo,
                value: 'false',
              },
            ],
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant.currentLoans.car',
          props: {
            isNumber: true,
            name: 'amount',
            placeholder: textResource.carLoansAmountPlaceholder,
            tooltip: tooltip(textResource.carLoanAmountTooltip),
            label: textResource.carLoansAmountLabel,
            type: 'tel',
            layout: {
              start: 1,
              end: 4,
            },
            validate: validateCurrentLoans,
            hasValidateFunction: true,
            visibleWhen: 'return (formState.values.applicant.hasCarLoan === true);',
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant.currentLoans.car',
          props: {
            isNumber: true,
            name: 'monthlyCost',
            tooltip: tooltip(textResource.carLoansMonthlyCostTooltip),
            placeholder: textResource.carLoansMonthlyCostPlaceholder,
            label: textResource.carLoansMonthlyCostLabel,
            type: 'tel',
            buttonLayout: 'toggle',
            validate: validateMonthlyCostCurrentLoans,
            hasValidateFunction: true,
            visibleWhen: 'return (formState.values.applicant.hasCarLoan === true);',
            layout: {
              start: 4,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'applicant',
          props: {
            name: 'carLoanPart',
            label: textResource.carLoansPartLabel,
            hasValidateFunction: true,
            buttonLayout: 'toggle',
            visibleWhen: 'return (formState.values.applicant.hasCarLoan === true);',
            layout: {
              start: 1,
              end: 7,
            },
            buttons: [
              {
                label: textResource.carLoansLoanIsOwnedByApplicant,
                value: '100',
              },
              {
                label: textResource.carLoansLoanIsSharedWithCoApplicant,
                value: '50',
              },
            ],
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'applicant',
          props: {
            name: 'hasStudentLoan',
            label: textResource.studentLoansLabel,
            tooltip: tooltip(textResource.studentLoanTooltip),
            hasValidateFunction: true,
            layout: {
              start: 1,
              end: 7,
            },
            validate: validateRequiredButtonGroup,
            buttonLayout: 'toggle',
            buttons: [
              {
                label: textResource.mergeLoanYes,
                value: 'true',
              },
              {
                label: textResource.mergeLoanNo,
                value: 'false',
              },
            ],
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant.currentLoans.studentLoan',
          props: {
            isNumber: true,
            name: 'amount',
            tooltip: tooltip(textResource.studentLoanAmountTooltip),
            label: textResource.studentLoansAmountLabel,
            placeholder: textResource.studentLoansAmountPlaceholder,
            type: 'tel',
            validate: validateCurrentLoans,
            layout: {
              start: 1,
              end: 4,
            },
            hasValidateFunction: true,
            visibleWhen: 'return (formState.values.applicant.hasStudentLoan === true);',
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'applicant.currentLoans.studentLoan',
          props: {
            isNumber: true,
            name: 'monthlyCost',
            tooltip: tooltip(textResource.studentLoanMonthlyCostTooltip),
            label: textResource.studentLoansMonthlyCostLabel,
            placeholder: textResource.studentLoansMonthlyCostPlaceholder,
            type: 'tel',
            validate: validateMonthlyCostCurrentLoans,
            hasValidateFunction: true,
            layout: {
              start: 4,
              end: 7,
            },
            visibleWhen: 'return (formState.values.applicant.hasStudentLoan === true);',
          },
        },
        {
          component: 'Break',
          props: {
            shade: 'down',
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'TotalAmountDisplay',
          props: {
            name: 'totalAmount',
            totalAmountLabel: textResource.totalAmoutDisplay,
            hasValidateFunction: true,
            lead: true,
            showButtons: true,
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'RepaymentTimeDisplay',
          props: {
            name: 'repaymentTime',
            repaymentTimeLabel: textResource.repaymentTimeDisplay,
            hasValidateFunction: true,
            lead: true,
            showButtons: true,
            layout: {
              start: 4,
              end: 7,
            },
          },
        },
      ],
    },
    {
      title: textResource.slideTitleFive,
      fullview: false,
      coApplicantSlide: true,
      showBackButton: true,
      fields: [
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'coApplicant',
          props: {
            name: 'phoneNumber',
            label: textResource.coApplicantPhoneNumberLabel,
            placeholder: textResource.coApplicantPhoneNumberPlaceholder,
            validate: phoneNumber,
            hasValidateFunction: true,
            type: 'tel',
            tooltip: tooltip(textResource.coApplicantPhoneNumberTooltip),
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'EmailInput',
          sectionName: 'coApplicant',
          props: {
            name: 'email',
            label: textResource.coApplicantEmailLabel,
            placeholder: textResource.coApplicantEmailPlaceholder,
            validate: email,
            tooltip: tooltip(textResource.coApplicantEmailTooltip),
            layout: {
              start: 4,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'coApplicant',
          props: {
            name: 'nationalId',
            label: textResource.coApplicantNationalIdLabel,
            placeholder: textResource.coApplicantNationalIdPlaceholder,
            validate: validateNationalId,
            hasValidateFunction: true,
            tooltip: tooltip(textResource.coApplicantNationalIdTooltip),
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'coApplicant',
          props: {
            name: 'civilStatus',
            label: textResource.coApplicantCivilStatusLabel,
            hasValidateFunction: true,
            validate: civilStatus,
            buttons: MARITAL_STATUS,
            tooltip: tooltip(textResource.coApplicantCivilStatusTooltip),
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'coApplicant',
          props: {
            name: 'dependants',
            label: textResource.coApplicantDependantsLabel,
            hasValidateFunction: true,
            validate: dependants,
            buttons: DEPENDANTS,
            tooltip: tooltip(textResource.coApplicantDependantsTooltip),
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'coApplicant',
          props: {
            name: 'educationLevel',
            hasValidateFunction: true,
            validate: validateRequiredButtonGroup,
            label: textResource.coApplicantEducationLabel,
            placeholder: textResource.coApplicantEducationLabel,
            buttons: EDUCATION_TYPES,
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'coApplicant',
          props: {
            name: 'employmentType',
            label: textResource.coApplicantEmploymentTypeLabel,
            hasValidateFunction: true,
            validate: employmentType,
            buttons: EMPLOYMENT_TYPES,
            tooltip: tooltip(textResource.coApplicantEmploymentTypeTooltip),
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'coApplicant',
          props: {
            name: 'employerName',
            validate: employerName,
            hasValidateFunction: true,
            sectionName: 'coApplicant',
            label: textResource.coApplicantEmployerNameLabel,
            placeholder: textResource.coApplicantEmployerNamePlaceholder,
            tooltip: tooltip(textResource.coApplicantEmployerNameTooltip),
            layout: {
              start: 1,
              end: 4,
            },
            visibleWhen: 'return (formState.values.coApplicant.employmentType !== undefined && formState.values.coApplicant.employmentType !== "disabilityPension" && formState.values.coApplicant.employmentType !== "retired");',
          },
        },
        {
          component: 'EmploymentSinceInputYear',
          sectionName: 'coApplicant',
          props: {
            name: 'employmentSince',
            validate: validateEmploymentSinceYear,
            label: textResource.coApplicantEmploymentSinceYearLabel,
            dynamicLabel: [
              {
                key: 'employmentType',
                originalLabel: textResource.coApplicantEmploymentSinceYearLabel,
                values: [
                  {
                    name: 'selfEmployed',
                    sectionName: 'coApplicant',
                    label: textResource.selfEmployedSinceYearDynamicLabel,
                  },
                  {
                    name: 'student',
                    sectionName: 'coApplicant',
                    label: textResource.studentSinceDynamicLabel,
                  },
                  {
                    name: 'retired',
                    sectionName: 'coApplicant',
                    label: textResource.retiredSinceDynamicLabel,
                  },
                  {
                    name: 'disabilityPension',
                    sectionName: 'coApplicant',
                    label: textResource.disabilityPensionSinceDynamicLabel,
                  },
                  {
                    name: 'unemployed',
                    sectionName: 'coApplicant',
                    label: textResource.unemployedSinceDynamicLabel,
                  },
                ],
              },
            ],
            placeholder: textResource.coApplicantEmploymentSinceYearPlaceholder,
            hasValidateFunction: true,
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'EmploymentSinceInputMonth',
          sectionName: 'coApplicant',
          props: {
            name: 'employmentSinceMonth',
            validate: validateEmploymentSinceMonth,
            hasValidateFunction: true,
            dynamicLabel: [
              {
                key: 'employmentType',
                originalLabel: textResource.coApplicantEmploymentSinceMonthLabel,
                values: [
                  {
                    name: 'selfEmployed',
                    sectionName: 'coApplicant',
                    label: textResource.selfEmployedSinceMonthDynamicLabel,
                  },
                  {
                    name: 'student',
                    sectionName: 'coApplicant',
                    label: textResource.studentSinceMonthDynamicLabel,
                  },
                  {
                    name: 'retired',
                    sectionName: 'coApplicant',
                    label: textResource.retiredSinceMonthDynamicLabel,
                  },
                  {
                    name: 'disabilityPension',
                    sectionName: 'coApplicant',
                    label: textResource.disabilityPensionSinceMonthsDynamicLabel,
                  },
                ],
              },
            ],
            label: textResource.coApplicantEmploymentSinceMonthLabel,
            placeholder: textResource.coApplicantEmploymentSinceMonthPlaceholder,
            visibleWhen: 'return (formState.values.coApplicant.employmentSince > new Date().getFullYear() - 4);',
            layout: {
              start: 4,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'coApplicant',
          props: {
            name: 'annualIncomeBeforeTax',
            isNumber: true,
            label: textResource.coApplicantAnnualIncomeBeforeTaxLabel,
            placeholder: textResource.coApplicantMonthlyIncomeBeforeTaxPlaceholder,
            validate: validateAnnualSalaryBeforeTax,
            hasValidateFunction: true,
            type: 'tel',
            tooltip: tooltip(textResource.coApplicantAnnualIncomeBeforeTaxTooltip),
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'coApplicant',
          props: {
            name: 'monthlyIncomeAfterTax',
            isNumber: true,
            label: textResource.coApplicantMonthlyIncomeAfterTaxLabel,
            placeholder: textResource.coApplicantMonthlyIncomeAfterTaxPlaceholder,
            validate: monthlySalaryAfterTax,
            tooltip: tooltip(textResource.coApplicantMonthlyIncomeAfterTaxTooltip),
            hasValidateFunction: true,
            type: 'tel',
            layout: {
              start: 4,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'coApplicant',
          props: {
            name: 'otherIncome',
            label: textResource.coApplicantOtherIncomeLabel,
            hasValidateFunction: true,
            buttonLayout: 'toggle',
            validate: mergeLoan,
            layout: {
              start: 1,
              end: 7,
            },
            buttons: [
              {
                label: textResource.mergeLoanYes,
                value: 'true',
              },
              {
                label: textResource.mergeLoanNo,
                value: 'false',
              },
            ],
            tooltip: tooltip(textResource.coApplicantOtherIncomeTooltip),
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'coApplicant',
          props: {
            isNumber: true,
            name: 'otherMonthlyIncomeAfterTax',
            placeholder: textResource.coApplicantNetOtherIncomePlaceholder,
            validate: otherIncomeAfterTax,
            hasValidateFunction: true,
            label: textResource.coApplicantNetOtherIncomeLabel,
            type: 'tel',
            visibleWhen: 'return (formState.values.coApplicant.otherIncome !== undefined && formState.values.coApplicant.otherIncome === true);',
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'coApplicant',
          props: {
            name: 'homeType',
            label: textResource.coApplicantHomeTypeLabel,
            hasValidateFunction: true,
            validate: homeType,
            tooltip: tooltip(textResource.coApplicantHomeTypeTooltip),
            buttons: HOME_TYPES,
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'EmploymentSinceInputYear',
          sectionName: 'coApplicant',
          props: {
            name: 'moveInDate',
            label: textResource.moveInDateLabelCoApplicant,
            placeholder: textResource.moveInDatePlaceholderCoApplicant,
            validate: validateMoveInDate,
            hasValidateFunction: true,
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'coApplicant',
          props: {
            name: 'homeCost',
            isNumber: true,
            label: textResource.coApplicantHomeCostLabel,
            placeholder: textResource.coApplicantHomeCostPlaceholder,
            validate: homeCost,
            hasValidateFunction: true,
            type: 'tel',
            tooltip: tooltip(textResource.coApplicantHomeCostTooltip),
            layout: {
              start: 4,
              end: 7,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'ButtonGroup',
          sectionName: 'coApplicant',
          props: {
            name: 'hasRentalIncome',
            label: textResource.coApplicantHasRentalIncomeLabel,
            hasValidateFunction: true,
            buttonLayout: 'toggle',
            validate: mergeLoan,
            buttons: [
              {
                label: textResource.mergeLoanYes,
                value: 'true',
              },
              {
                label: textResource.mergeLoanNo,
                value: 'false',
              },
            ],
            tooltip: tooltip(textResource.coApplicantHasRentalIncomeTooltip),
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'ValidatedForm',
          form: 'TextInput',
          sectionName: 'coApplicant',
          props: {
            name: 'rentalMonthlyIncomeBeforeTax',
            isNumber: true,
            label: textResource.coApplicantRentalMonthlyIncomeBeforeTaxLabel,
            placeholder: textResource.coApplicantRentalMonthlyIncomeBeforeTaxPlaceholder,
            type: 'tel',
            visibleWhen: 'return (formState.values.coApplicant.hasRentalIncome);',
            validate: validateRentalIncome,
            layout: {
              start: 1,
              end: 4,
            },
          },
        },
        {
          component: 'Break',
          props: {
            shade: 'down',
            layout: {
              start: 1,
              end: 7,
            },
          },
        },
        {
          component: 'TotalAmountDisplay',
          props: {
            name: 'totalAmount',
            totalAmountLabel: textResource.totalAmoutDisplay,
            hasValidateFunction: true,
            lead: true,
            showButtons: true,
            layout: {
              start: 1,
              end: 3,
            },
          },
        },
        {
          component: 'RepaymentTimeDisplay',
          props: {
            name: 'repaymentTime',
            repaymentTimeLabel: textResource.repaymentTimeDisplay,
            hasValidateFunction: true,
            lead: true,
            showButtons: true,
            layout: {
              start: 3,
              end: 5,
            },
          },
        },
      ],
    },
  ],
};

export default data;
